<template>
<div>auth</div>
</template>

<script>
export default {
  name: "auth"
}
</script>

<style scoped>

</style>
